import React from "react";

import colors from "core/colors";

const MobilePhotoSvg = () => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            title="Photos"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 3.49999V12.8333H2.33333V3.49999H14ZM6.06597 6.21211L3.48925 11.661H11.6948L9.26257 7.42603L8.13491 9.81245L6.06597 6.21211ZM11.6667 1.16666V2.34664H1.19244V10.5H0V1.16666H11.6667ZM11.3951 5.2524C10.9089 5.2524 10.5148 5.64361 10.5148 6.12619C10.5148 6.60878 10.9089 6.99999 11.3951 6.99999C11.8813 6.99999 12.2754 6.60878 12.2754 6.12619C12.2754 5.64361 11.8813 5.2524 11.3951 5.2524Z"
                fill={colors.fossil}
            />
        </svg>
    );
};

export default MobilePhotoSvg;
